const user = {
  state: {

  },
  mutations: {

  },
  actions: {

  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js